import { getSureStartProgramData } from './add-Page-Type-DataLayer';

export function gtmCustomEventLeadFlow(leadObj:any){
    let dataLayer = (window as any).dataLayer;
    dataLayer?.push({
        ...leadObj,
        ...getSureStartProgramData()
    });
}

// Clear all tracked events
export const clearAllGTMTrackedEvents = (eventType: string = '') => {
    let dataLayer = (window as any).dataLayer;
    if (!dataLayer) return;

    for (let i = dataLayer.length - 1; i >= 0; i--) {
        if (dataLayer[i]?.['event'] === eventType) {
            dataLayer.splice(i, 1);
        }
    }
};